import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

const faqs: FAQItem[] = [
  {
    question: '蘑菇视频官网是什么？',
    answer: '蘑菇视频官网是蘑菇视频的官方正版入口，提供海量高清视频内容的在线观看与下载服务。平台涵盖电影、电视剧、综艺、动漫、纪录片等丰富品类，支持4K超清画质和杜比全景声音效，是您值得信赖的视频娱乐平台。',
  },
  {
    question: '如何在蘑菇视频官网下载APP？',
    answer: '您可以在蘑菇视频官网首页点击"下载APP"按钮，根据您的设备类型选择iOS或Android版本进行下载安装。也可在苹果App Store或各大安卓应用商店搜索"蘑菇视频"直接下载官方正版APP。',
  },
  {
    question: '蘑菇视频会员有哪些权益？',
    answer: '蘑菇视频会员可享受八大核心权益：4K超清画质、杜比全景声、多端同步观看、抢先看热门剧集、免广告打扰、离线下载、专属客服、会员专属内容。会员价格实惠，性价比极高。',
  },
  {
    question: '蘑菇视频官网支持哪些设备观看？',
    answer: '蘑菇视频官网支持手机（iOS/Android）、平板、电脑（Windows/Mac）、智能电视（TV版）等多种设备。一个会员账号可在四台设备上同时登录使用，满足全家人的观影需求。',
  },
  {
    question: '蘑菇视频的内容是否为正版？',
    answer: '是的，蘑菇视频官网的所有视频内容均为正版授权。我们与国内外众多影视制作公司、发行方建立了长期合作关系，确保每一部作品都拥有合法版权，为用户提供安全可靠的观影体验。',
  },
  {
    question: '如何联系蘑菇视频客服？',
    answer: '您可以通过以下方式联系我们：拨打客服热线400-888-9999（7×24小时）、发送邮件至support@moguvideo.com、或在蘑菇视频APP内使用在线客服功能。会员用户还可享受专属客服通道，获得更快速的响应服务。',
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-3" style={{ fontFamily: "var(--font-heading)" }}>
            常见问题
          </h2>
          <p className="text-sm text-foreground-500">
            关于蘑菇视频官网的常见疑问，这里都有答案
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="rounded-xl bg-background-100 overflow-hidden transition-all duration-200"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex items-center justify-between gap-4 p-5 text-left"
              >
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 pr-2">
                  {faq.question}
                </h3>
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i
                    className={`ri-${
                      openIndex === index ? 'subtract' : 'add'
                    }-line text-lg text-foreground-500 transition-transform duration-200`}
                  ></i>
                </div>
              </button>
              {openIndex === index && (
                <div className="px-5 pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'FAQPage',
          mainEntity: faqs.map((faq) => ({
            '@type': 'Question',
            name: faq.question,
            acceptedAnswer: {
              '@type': 'Answer',
              text: faq.answer,
            },
          })),
        })}
      </script>
    </section>
  );
}